import { render, staticRenderFns } from "./PrimaryItem.vue?vue&type=template&id=de4aa9c8"
import script from "./PrimaryItem.vue?vue&type=script&lang=ts"
export * from "./PrimaryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports